//@flow
import Collection from '../../Utils/Collection/parsedCollection';
import ProductModel from './productModel';
import type { ProductObject } from './productModel';
import _ from 'underscore';

import type { QuoteItemObject } from '../Quote/quoteItemModel';
import type { Filter } from '../Filters/filtersStoreClass';

export default class ProductsCollection extends Collection<ProductObject, ProductModel> {
  __modelClass() {
    return ProductModel;
  }

  getProductsByIds(idsArray:?string[]):ProductModel[] {
    return this._getModelsByAttributes('id', idsArray);
  }

  getProductById(id:string):?ProductModel {
    return this._getModelByAttribute('id', id);
  }

  getProductsBySkus(skusArray:?string[]):ProductModel[] {
    return this._getModelsByAttributes('sku', skusArray);
  }

  getProductBySku(sku:string):?ProductModel {
    return this._getModelByAttribute('sku', sku);
  }

  getProductByUrlKey(urlKey:string):?ProductModel {
    return this._getModelByAttribute('url_key', urlKey);
  }

  getFilteredProducts(filters:Filter[], skus:?string[]):ProductModel[] {
    const products = skus ? this.getProductsBySkus(skus) : this.models;
    const filterNames = filters.map(filter => filter.name);
    if (!products) return [];

    const filteredProducts = [];
    _.each(products, (product) => {
      if (product.passFilters(filterNames)) filteredProducts.push(product);
    });

    return filteredProducts;
  }

  getSkus():string[] {
    return this.models.map(product => product.getSku());
  }

  getNotAllowedCountryReasons(country:string, skus:?string[]):?string[] {
    const products = skus ? this.getProductsBySkus(skus) : this.models;
    const reasons = products && products.reduce((prev, product) => {
      const productReasons = product.getNotAllowedCountryReasons(country) || [];
      return prev.concat(productReasons);
    }, []);

    return reasons && _.uniq(reasons);
  }

  isLoaded():boolean {
    return this.models.length > 0;
  }

  getTotalMemberPrice(items:?$Shape<QuoteItemObject>[]):number {
    if (!items) return 0;

    const total = items.reduce((prev, item:QuoteItemObject) => {
      //for gift vouchers, the correct price is on the quoteItem rather than the product
      if (item.product_type === 'giftvoucher') return prev + item.regular_price;

      const product = this.getProductBySku(item.sku);
      if (!product) return prev;

      const productTotal = product.getMemberPriceFloat();
      return prev + (productTotal * item.qty);
    }, 0);

    return total;
  }
}
